import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import QuestionnaireContext from '../QuestionnaireContext';

const useToggleButtonGroupStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  grouped: {
    padding: 25,
    '&:not(:first-child), &:not(:last-child)': {
      marginLeft: 'inherit',
      borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
}));
const useToggleButtonStyle = makeStyles({
  root: {
    minHeight: 100,
    flex: '0 0 200px',
    margin: 25,
  },
});

const Buttons = ({
  options,
  questionId,
  onPush,
  onRemove,
  onChange,
  handleValidation,
  selectedAll,
  className,
}) => {
  const { setParam } = useContext(QuestionnaireContext);
  const [currentValue, setCurrentValue] = useState(
    selectedAll ? options.map(({ answerId }) => answerId) : [],
  );
  const toggleButtonGroupClasses = useToggleButtonGroupStyles();
  const toggleButtonClasses = useToggleButtonStyle();

  const setValidate = value => {
    if (handleValidation) {
      setParam('isValidate', value);
    }
  };

  useEffect(() => {
    onRemove(questionId);
    if (onChange) {
      onChange(currentValue);
    }

    if (currentValue.length) {
      currentValue.forEach(singleValue => onPush(questionId, singleValue));
      setValidate(true);
    } else {
      setValidate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  const handleChange = (event, answerId) => {
    if (answerId === null) {
      return;
    }

    setCurrentValue(answerId);
  };

  return (
    <>
      <div>
        <ToggleButtonGroup
          onChange={handleChange}
          value={currentValue}
          classes={toggleButtonGroupClasses}
        >
          {options.map(({ answerLabel, answerId }) => (
            <ToggleButton
              key={answerId}
              value={answerId}
              className={clsx(toggleButtonClasses.root, className)}
            >
              {answerLabel}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
    </>
  );
};

Buttons.defaultProps = {
  handleValidation: true,
  onChange: undefined,
  selectedAll: true,
  className: undefined,
};

Buttons.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.number.isRequired,
      answerLabel: PropTypes.string.isRequired,
      answerName: PropTypes.string.isRequired,
      type: PropTypes.string,
    }),
  ).isRequired,
  questionId: PropTypes.number.isRequired,
  handleValidation: PropTypes.bool,
  onPush: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  selectedAll: PropTypes.bool,
  className: PropTypes.string,
};

export { Buttons };
